export const MONITORING_TOP_COLUMNS = ['name', 'count'];

export const MONITORING_TOP_LIMIT = 10;
